import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { PlanMarkerCreateComponent } from './plan-marker-create.component';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

@NgModule({
    imports: [CommonModule, FormsModule, IonicModule, SharedModule, ColorPickerModule, FontAwesomeModule],
    declarations: [PlanMarkerCreateComponent],
    exports: [PlanMarkerCreateComponent]
})
export class PlanMarkerCreateModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}
